import React from 'react'
import { deepFind, deepFilter } from 'react-children-utilities'
import PropTypes from 'prop-types'

function isReactElement(node) {
  return React.isValidElement(node)
}

const Close = ({ children }) => <>{children}</>
const FooterLeft = ({ children }) => <>{children}</>
const FooterRight = ({ children }) => <>{children}</>
const Title = ({ children }) => <>{children}</>
const Col = ({ children }) => <>{children}</>

const Header = ({ children }) => <>{children}</>
Header.Title = Title
Header.Close = Close

const Body = ({ children }) => <>{children}</>
Body.Col = Col

const Footer = ({ children }) => <>{children}</>
Footer.Left = FooterLeft
Footer.Right = FooterRight

const CardConfigure = ({ children, ...rest }) => {
  const header = deepFind(children, child => child.type === Header)
  const body = deepFind(children, child => child.type === Body)
  const footer = deepFind(children, child => child.type === Footer)
  const footerLeft = deepFind(children, child => child.type === FooterLeft)
  const footerRight = deepFind(children, child => child.type === FooterRight)
  const title = deepFind(children, child => child.type === Title)

  const cols = deepFilter(isReactElement(body) ? body.props.children : [], child => child)

  function getPropsChildren(element) {
    return element?.props?.children ?? null
  }

  return (
    <div
      className="relative flex flex-col w-full mx-auto bg-white rounded-2xl shadow-[0_4px_16px_#0000001f] max-h-[80vh] max-phone:max-h-[calc(100vh-3rem)]"
      {...rest}
    >
      {header && (
        <div className="flex justify-between items-center p-6 max-phone:px-4 h-22 box-border type-header-4 border-b border-grey-90">
          {getPropsChildren(title)}
        </div>
      )}

      {body && (
        <div className="p-6 max-phone:px-4 overflow-y-auto [scrollbar-width:thin] [scrollbar-color:var(--color-grey-90)_#f1f1f1] max-h-[calc(80vh-88px-76px)] max-phone:max-h-[calc(100vh-3rem-88px-76px)]">
          {cols
            ? cols.map((col, index) =>
                isReactElement(col) ? <div key={index}>{col?.props?.children}</div> : null
              )
            : null}
        </div>
      )}

      {footer && (
        <div className="flex h-19 p-6 max-phone:px-4 box-border rounded-b-2xl bg-grey-98">
          {footerLeft && <div className="flex items-center">{getPropsChildren(footerLeft)}</div>}
          {footerRight && (
            <div className="flex items-center ml-auto">{getPropsChildren(footerRight)}</div>
          )}
        </div>
      )}
    </div>
  )
}

CardConfigure.Header = Header
CardConfigure.Header.Title = Title
CardConfigure.Header.Close = Close
CardConfigure.Body = Body
CardConfigure.Body.Col = Col
CardConfigure.Footer = Footer
CardConfigure.Footer.Left = FooterLeft
CardConfigure.Footer.Right = FooterRight

CardConfigure.propTypes = {
  children: PropTypes.node,
}

Close.propTypes = { children: PropTypes.node }
FooterLeft.propTypes = { children: PropTypes.node }
FooterRight.propTypes = { children: PropTypes.node }
Title.propTypes = { children: PropTypes.node }
Col.propTypes = { children: PropTypes.node }
Header.propTypes = { children: PropTypes.node }
Body.propTypes = { children: PropTypes.node }
Footer.propTypes = { children: PropTypes.node }

export default CardConfigure
